import React from 'react';
import { cx } from '@travel/utils';
import UIStyledSelectBox, {
  Props as StyledSelectBoxProps,
  OptionItem as OptionItemProps,
} from '@travel/ui/components/StyledSelectBox';

import styles from './styledSelectBox.module.scss';

type Props<T> = {
  /** Custom style for select box title label */
  labelClassName?: string;
  /** Node of select box title label */
  label?: React.ReactNode;
} & StyledSelectBoxProps<T>;

function StyledSelectBox<T extends OptionItemProps>(props: Props<T>) {
  const inputId = `input-${props.name}`;

  return (
    <>
      {props.label && (
        <label htmlFor={inputId} className={cx(styles.label, props.labelClassName)}>
          {props.label}
        </label>
      )}
      <UIStyledSelectBox
        {...props}
        className={cx(styles.wrapper, props.className)}
        listClassName={cx(
          styles.list,
          props.listClassName,
          props.customStyle === 'popup' ? styles.popup : styles.dialog,
        )}
        placeholderClassName={styles.placeholder}
        displayBoxClassName={cx(styles.viewport, props.displayBoxClassName)}
        optionItemClassName={cx(styles.optionItem, props.optionItemClassName)}
        optionItemSelectedClassName={cx(
          styles.selectedOptionItem,
          props.optionItemSelectedClassName,
        )}
      />
    </>
  );
}

StyledSelectBox.defaultProps = {
  isOpen: false,
  customStyle: 'popup',
};

export default StyledSelectBox;
